import React from 'react';
import css from '../styles/area-nonprofit.css';

const { Component } = React;

class AreaNonprofit extends Component {
  render() {
    return (
      <div className="areas-grid-item areas-grid-item--nonprofit">
        <div class="areas-grid-item__wrapper">
          <div class="areas-area__hero">
          </div>
          <div class="areas-area__hero-text" data-aos="zoom-in">
            <h3>Nonprofit</h3>
            <p>I can help you decide on the right form for your new nonprofit organization and guide you through qualifying for Recognition of Exemption with the IRS for 501(c)(3)s and other types of charities.  I can also help with governance and compliance issues for your existing nonprofit.</p>
          </div>
        </div>
      </div>
    );
  }
}

export { AreaNonprofit };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Areas/components/area-nonprofit.js